import { useDispatch, useSelector } from 'react-redux';
import { setEditClient, updateClient } from '../../redux/actions/clients';
import { Dimmer, Loader, Table } from 'semantic-ui-react';

import Actions from '../Common/Actions';
import useClients from '../../hooks/useClients';
import { ReactNode, useState } from 'react';
import Filters from '../Common/Filters';
import { StoreState } from '../../types/state';
import { getLocalTime, timestampColumns } from '../../utils';

const ClientColumns = [
  { name: 'id', type: 'string' },
  { name: 'ClientName', type: 'string' },
  // { name: 'S3Folder', type: 'string' },
  { name: 'DBIdentifier', type: 'string' },
  { name: 'ManagedProperties', type: 'array' },
  { name: 'IsActive', type: 'string' },
  { name: 'CreatedOn', type: 'date' },
  // { name: 'UpdatedOn', type: 'string' },
  { name: 'PMSId', type: 'string' },
  // { name: 'CredentialId', type: 'string' },
  { name: 'City', type: 'string' },
  { name: 'TimeZone', type: 'string' },
  { name: 'ModuleIds', type: 'array' },
  { name: 'ClientType', type: 'string' },
];

const ClientList = () => {
  const { clients, isLoading } = useClients();
  const timezone = useSelector((state: StoreState) => state.auth.timezone);
  const useLocalTime = timezone === 'UTC' ? false : true;

  const dispatch = useDispatch();

  const handleDisable = (id: string) => {
    const client = clients[id];
    if (client) {
      dispatch(
        updateClient({ data: { ...client, IsActive: !client.IsActive } })
      );
    }
  };

  const clientIds = Object.keys(clients);
  const [filteredClients, setFilteredClients] = useState([]);

  return (
    <div>
      {isLoading ? (
        <Dimmer page>
          <Loader />
        </Dimmer>
      ) : (
        clientIds.length > 0 && (
          <>
            <Filters
              originalList={Object.values(clients)}
              filteredLists={filteredClients}
              allowedParams={[
                'ClientName',
                'DBIdentifier',
                'IsActive',
                'ClientType',
                'City',
                'id',
              ]}
              setFilteredLists={setFilteredClients}
            />

            <Table size="small">
              <Table.Header>
                <Table.Row>
                  {ClientColumns.map((elem) => {
                    return (
                      <Table.HeaderCell key={elem.name.toString()}>
                        {elem.name.toString()}
                      </Table.HeaderCell>
                    );
                  })}
                  <Table.HeaderCell>Actions</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {filteredClients.map((client) => {
                  return (
                    <Table.Row key={client.id}>
                      {ClientColumns.map(
                        ({ name: columnName, type }): ReactNode => {
                          return (
                            <Table.Cell key={columnName + client.id}>
                              <span
                                className={type === 'array' ? 'cell-array' : ''}
                              >
                                {timestampColumns.includes(columnName) &&
                                useLocalTime
                                  ? getLocalTime(client[columnName])
                                  : client[columnName] === false
                                  ? 'false'
                                  : client[columnName]
                                  ? type === 'array'
                                    ? client[columnName].map((propertyId) => {
                                        return (
                                          <p key={propertyId}>{propertyId}</p>
                                        );
                                      })
                                    : client[columnName].toString()
                                  : null}
                              </span>
                            </Table.Cell>
                          );
                        }
                      ).concat(
                        <Table.Cell key={`${client.id}-actions`}>
                          <Actions
                            showEdit
                            showEnable
                            showDetails
                            isDisabled={!client.IsActive}
                            onDisable={() => {
                              handleDisable(client.id);
                            }}
                            onEdit={() => {
                              dispatch(setEditClient(client));
                            }}
                            detailsLink={`/clients/view/${client.id}`}
                          />
                        </Table.Cell>
                      )}
                    </Table.Row>
                  );
                })}
              </Table.Body>
            </Table>
          </>
        )
      )}
    </div>
  );
};

export default ClientList;
